module.exports = __webpack_public_path__ + "static/media/git.2d78f493.png";